import gql from 'graphql-tag';
import { AssetImageSubtype } from 'src/modules/assets';
// export const FRAGMENT_PRODUCT = gql`
//   fragment productFields on Product {
//     id
//     name_en
//     name_de
//     slug
//     product_categories {
//       id
//       slug
//     }
//     product_subcategories @include(if: $withFilters) {
//       id
//       name_en
//       name_de
//     }
//     location_types @include(if: $withFilters) {
//       id
//       name_en
//       name_de
//     }
//     assets(where: { channels_in: $mediaOutputChannel }, sort: "sorting:asc") {
//       ...assetsFields
//     }
//     product_series {
//       id
//       slug
//       name_en
//       name_de
//       plp_display
//       designer {
//         id
//         name
//       }
//     }
//   }
//   ${QUERY_ASSETS}
// `;

export const FRAGMENT_PRODUCT_CARD = gql`
  fragment productCardFields on Product {
    id
    name_en
    name_de
    channels
    slug
    product_categories {
      id
      slug
    }
    product_subcategories @include(if: $withFilters) {
      id
      name_en
      name_de
    }
    location_types @include(if: $withFilters) {
      id
      name_en
      name_de
    }
    assets(where: {subtype: "${AssetImageSubtype.Cutout}"}, sort: "sorting:asc", limit: 1) {
    # assets(where: {subtype: "${AssetImageSubtype.Preview}"}) {
      subtype
      file {
        url
        alternativeText
        # width
        # height
      }
    }
    product_series {
      slug
      name_en
      name_de
      designer {
        id
        name
      }
    }
  }
`;
